<template>
     <AlertReplacement :alertInfo="alertInfo" :trigger="alertTrigger"
              @alert-result="alertResult"></AlertReplacement>
  <div>
    <ion-menu swipeGesture="false" menu-id="program-menu" content-id="main-content">
    <ion-header>
      <ion-toolbar>
        <ion-title>Chessvis</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>

      <ion-item color=primary @click="menuItemClick('home',null)">
        <ion-label>
          <b>{{ t("Home Menu") }}</b>
        </ion-label>
      </ion-item>

      <ion-accordion-group :value="accordionToOpen">

        <div v-for="group in menuGroups" v-bind:key="group.index + keyAdder">

        <!-- *** Opening Mastery *** -->
        <ion-accordion :value="group.value"  >
          <ion-item slot="header">
            <ion-icon :icon="group.icon" slot="start"></ion-icon>
            <ion-label>
              {{ group.label }}
            </ion-label>
          </ion-item>
          <ion-list slot="content">
            <div v-for="item in group.menuItems" v-bind:key="item.index + keyAdder">
              <ion-item class="accordion_item">
                <ion-label  @click="menuItemClick(item,group)">
                    {{ item.label }}
                </ion-label>
                <ion-icon v-if="showIcon(item,'locked')" :icon="lockClosedOutline" slot="end">
                </ion-icon>
                <ion-icon v-if="showIcon(item,'offline')" :icon="offlineIcon" slot="end">
                </ion-icon>
                <ion-icon v-if="showIcon(item,'help')" @click="helpItemClick(item,group)" :icon="helpIcon" slot="end">
                </ion-icon>
              </ion-item>
            </div>
          </ion-list>
        </ion-accordion>
        </div>

      </ion-accordion-group>
    </ion-content>
  </ion-menu>
</div>
</template>

<script setup >
  import {IonIcon, IonLabel,IonMenuToggle, IonList,IonItem,IonAccordionGroup,IonAccordion, IonButtons, IonContent, IonHeader, IonMenu, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/vue';

  import { informationOutline, informationCircle, lockClosedOutline, flashOffOutline, bulbOutline,
          helpCircle, videocam, videocamOutline, bookOutline, medalOutline,
          extensionPuzzleOutline, eyeOffOutline, telescopeOutline, bodyOutline,
          schoolOutline, micOutline,
  caretForwardOutline , helpCircleSharp, helpCircleOutline, helpOutline} from 'ionicons/icons';

import { ref, onMounted, onBeforeUnmount } from 'vue'
import AlertReplacement from '@/components/AlertReplacement.vue'

import { useConnectionStore } from '@/stores/connectionStore';
import { computed } from "@vue/reactivity"

import { t } from '@/composables/translateText.js'

const emit = defineEmits(['menu-item-click','menu-help-item-click'])

const connectionStore = useConnectionStore()
const deviceType = connectionStore.getDeviceType

const lichessAccessToken = connectionStore.getLichessAccessToken

const alertInfo = ref({})
const alertTrigger = ref(0)

const accordionToOpen = ref(connectionStore.getProgramAccordionToOpen)

const keyAdder = ref(0)
var isOffline = !navigator.onLine
var attemptCountString = connectionStore.getPuzzleAttemptCount
var puzzleCountString = connectionStore.getPuzzleCount
      
const isSubscriber = connectionStore.getIsSubscriber

const helpIcon = ref(informationCircle)
const offlineIcon = ref(flashOffOutline)
const mustBeSubscriberIcon = ref(lockClosedOutline)

const openingMenuItems = ref([
  { index : 0, label : t("Explorer"), program : "explorer" , help : false},
  { index : 1, label : "AI " + t("Explorer"), program : "ai_explorer" , subscriber : true,help : false},
  { index : 2, label : t("Download Your Games"), program : "download" , subscriber : true},
  { index : 3, label : t("Analyze Your Games"), program : "exploreUserGames" , subscriber : true},
  // { index : 3, label : "Opening Audio Book", program : "openingAudioBooks" , subscriber : false},
])

const repertoireMenuItems = ref([
  { index : 0, label : t("Manager"), program : "repmanager", subscriber : true },
  { index : 1, label : t("Builder"), program : "repbuilder" , subscriber : true},
  { index : 2, label : t("Tree Viewer"), program : "reptree" , subscriber : true},
  { index : 3, label : t("Drill"), program : "repdrill" , subscriber : true},
  { index : 4, label : t("Practice"), program : "reppractice" , subscriber : true},
  { index : 5, label : t("Export"), program : "repexport" , subscriber : true}
])

const PUZZLE_MENU_DOWNLOAD_INDEX = 5

const puzzleMenuItems = ref([])

const puzzleItems = [
{ index : 0, label : t("Puzzles"), program : "puzzles" , 
                                help : true, canOffline : true},
{ index : 1, label : t("Puzzle Visualization"), program : "puzzle_visualize" , 
                                help : true, canOffline : true},
{ index : 2, label : t("Timed Puzzles"), program : "puzzle_timed" , 
                                help : true, canOffline : true},
{ index : 3, label : t("Timed Visualized Puzzles"), program : "puzzle_timed_visualize" , 
                                help : true, canOffline : true},
{ index : 4, label : t("Blindfold Puzzles"), program : "puzzle_blindfold" , 
                                help : true, canOffline : true},
// { index : 5, label : t("Custom Categories"), program : "custom_categories" , 
//                                 subscriber : true}
]

const puzzleOfflineAvailable = { index : 5, label : t("Download for Offline Play"), 
              program : "puzzle_offline" , help : false, subscriber : false}
const puzzlesWorkOffline = { index : 6, label : t("Switch to Offline Puzzles"), 
              program : "puzzle_offline_toggle" , help : false, subscriber : false}

const puzzleHistory = { index : 7, label : t("Puzzle History & Download"), 
              program : "puzzle_history" , help : false, subscriber : false}

const visualizationMenuItems = ref([
  { index : 0, label : t("Who's Guarding Whom"), program : "guarding" , help : true},
  { index : 1, label : t("Static Boards"), program : "static" , help : true},
  { index : 2, label : t("Moves At Random Location"), program : "moves_random" , help : true},
  { index : 3, label : t("Moves From Game Beginning"), program : "moves_begin" , help : true},
  { index : 4, label : t("Follow Specific Pieces"), program : "moves_pieces" , help : true},
])

const blindfoldContinueGameItem =  { index : 0, label : t("Continue Game?"), 
                      program : "play_continue" , help : true}
 
const blindfoldItems = [
  { index : 1, label : t("Play Computer"), program : "play_computer" , help : true},
  { index : 2, label : t("Play Blindfold"), program : "play_blindfold" , help : true},
  { index : 3, label : t("Game History"), program : "blindfold_history" , help : true},
  { index : 4, label : t("Blindfold Puzzles"), program : "puzzle_blindfold" , 
                                help : true, subscriber : true, canOffline : true},
]

  const otherProgramsMenuItems = ref([
    { index : 0, label : "Verbal Chess", program : "verbal_play" },
    { index : 1, label : "Chessvis AI" , program : "chessvis_ai" },
  ])

  const aiMenuItems = ref([
    { index : 0, label : "Game Source", program : "ai_game_source", help : false},
    { index : 1, label : "Game Analysis", program : "ai_analyst", help : false},
    { index : 2, label : "Chess Chatbot", program : "chess_chatbot", help : false}
  ])

const blindfoldMenuItems = ref([])

const learnMenuItems = ref([])

const becomeACoach = { index : 2, label : t("Do You Coach or Get Coached?"), program : "pitch_coach", help : false}
const learnWithCoach = { index : 3, label : t("Learn With Coach"), program : "shared_board" , help : false}

const lichessConnectItem =   { index : 0, label : t("Connect to Lichess (do first)"), 
                                  program : "lichess_connect" , 
                                  help : false, needsLichessToken : false}
const lichessDisconnectItem =   { index : 0, label : t("Disconnect"), 
                                  program : "lichess_disconnect" , 
                                  help : false, needsLichessToken : true}

const lichessItems = [
  { index : 0, label : t("'Rapid' Pairing"), program : "lichess_rapid_challenge" , 
                            help : false, needsLichessToken : true },
  { index : 1, label : t("'Correspondence' Pairing"), program : "lichess_correspondence_challenge" , 
                            help : false,needsLichessToken : true},
  { index : 2, label : t("Challenge Friend"), program : "lichess_friend" , 
                            help : false, needsLichessToken : true},
  { index : 3, label : t("Arena Tournaments"), program : "lichess_arena" , 
                            help : false,needsLichessToken : true},
  { index : 4, label : t("Open Game List"), program : "lichess_open_gamelist" , 
                            help : false,needsLichessToken : true},
  { index : 5, label : t("BOT Challenge"), program : "lichess_bot_challenge" , 
                            help : false,needsLichessToken : true},
]

const lichessMenuItems = ref([])

const legacyOpeningMenuItems = ref([
  { index : 0, label : t("Opening Explorer - Win/Loss"), 
                          program : "legacy_opening_winloss" , help : true},
  { index : 1, label : t("Play Against Game Collection"), 
                          program : "legacy_play_collection" , help : true},
  { index : 2, label : t("Opening Explorer - Slice/Dice"), 
                          program : "legacy_opening_slicedice" , help : true, subscriber: true},
  { index : 3, label : t("Download Your Games"), program : "download" , help:true,subscriber : true},
  { index : 4, label : t("Master Player Explorer"), program : "legacy_master_player" , 
                                help : true, subscriber : true},
])

const legacyRepertoiresMenuItems = ref([
  { index : 0, label : t("Repertoire Manager"), 
                          program : "legacy_repertoire_manager" , help : false, subscriber : true},
  { index : 1, label : t("Repertoire Builder"), 
                          program : "legacy_repertoire_builder" , help : true, subscriber : true},
  { index : 2, label : t("Repertoire Tree"), 
                          program : "legacy_repertoire_tree" , help : true, subscriber : true},
  { index : 3, label : t("Repertoire Practice"), 
                          program : "legacy_repertoire_practice" , help : true, subscriber : true},
  { index : 4, label : t("Repertoire Export"), 
                          program : "legacy_repertoire_export" , help : false, subscriber : true},
  { index : 5, label : t("Repertoire Import (Web)"), 
                          program : "legacy_repertoire_import" , help : false, subscriber : true,
                          webOnly : true}
  ])

const PUZZLE_GROUP_NUMBER = 0
const BLINDFOLD_GROUP_NUMBER = 4
const LEARN_GROUP_NUMBER = 8
const LICHESS_GROUP_NUMBER = 9

const menuGroups = ref([
  { index : 0 , value: "puzzle", icon : extensionPuzzleOutline, 
                label : t("Puzzles"), menuItems : puzzleMenuItems.value},
  { index : 1 , value : "visualize", icon : telescopeOutline, 
                label : t("Visualization"), menuItems : visualizationMenuItems.value},
  { index : 2 , value:"opening",icon : medalOutline, 
                label: t("Opening Mastery"), menuItems : openingMenuItems.value},
  { index : 3 , value:"repertoire",icon : bookOutline, 
                label : t("Repertoires"), menuItems : repertoireMenuItems.value},
  { index : 4 , value : "blindfold", icon : eyeOffOutline, 
                label : t("Blindfold"), menuItems : blindfoldMenuItems.value},
  { index : 5 , value : "legacy_opening", 
                label : t("Legacy Opening"), menuItems : legacyOpeningMenuItems.value},
  { index : 6 , value : "legacy_repertoire", 
                label : t("Legacy Repertoires"), menuItems : legacyRepertoiresMenuItems.value},
  { index : 7 , value : "verbal", icon : micOutline,
                label : "Verbal & AI ", menuItems : otherProgramsMenuItems.value},
  { index : 8 , value : "learn",  icon : schoolOutline,
                label : t("Learn"), menuItems : learnMenuItems.value},
  { index : 9 , value : "lichess", icon : bodyOutline, 
                label : t("Lichess Play"), menuItems : lichessMenuItems.value},
])

  function setupAlert(header,message,type,task) {
    alertInfo.value = { header : header, message : message, type : type, task : task  }
    alertTrigger.value++
  }

  function alertResult(response,task,info) {
    //console.log("Alert Result",response,task)

    if (response == "no")
      return

    emit("menu-item-click","subscribe_blurb","Subscriber Benefits","program")
  }
  

// Alert End
onMounted(() => {
  // Experiment with this to time when to increment to force a rebuild
  keyAdder.value += 100

  //console.log("Program Menu Content Mounted")

  attemptCountString = connectionStore.getPuzzleAttemptCount
  puzzleCountString = connectionStore.getPuzzleCount

  isOffline = !navigator.onLine

  // patch the menu items

  var showOfflineToggle = false
  var offlineMenuItem = puzzleOfflineAvailable
  if (isSubscriber == 1)
    if (parseInt(attemptCountString) > 0) {
      offlineMenuItem.label = t("Sync Offline Attempts & Refresh")
      showOfflineToggle = true
    }
    else
      if (parseInt(puzzleCountString) > 0) {
        offlineMenuItem.label = t("Puzzles Available when Offline")
        showOfflineToggle = true
      }
  
  var workOfflinePuzzles = "no"
  if (showOfflineToggle)
    workOfflinePuzzles = connectionStore.getWorkOfflinePuzzles   

  puzzleMenuItems.value = []
  for (var i=0; i < puzzleItems.length; i++) {
    var oneMenuItem = puzzleItems[i]
    if (workOfflinePuzzles == "yes")
      oneMenuItem.label += " (" + t("Offline") + ")"
    puzzleMenuItems.value.push(oneMenuItem)
  }
  puzzleMenuItems.value.push(offlineMenuItem)
  if (showOfflineToggle) {
    var oneMenuItem = puzzlesWorkOffline
    if (workOfflinePuzzles == "yes")
      oneMenuItem.label = t("Switch to Online Puzzles")
    puzzleMenuItems.value.push(oneMenuItem)
  }

  puzzleMenuItems.value.push(puzzleHistory)

  menuGroups.value[PUZZLE_GROUP_NUMBER].menuItems = puzzleMenuItems.value

  // add "continue game" if available
  blindfoldMenuItems.value = []
  const openGameId = connectionStore.getPlayComputerGameId
  if (openGameId != "0")
    blindfoldMenuItems.value.push(blindfoldContinueGameItem)
  for (var i=0; i < blindfoldItems.length; i++)
    blindfoldMenuItems.value.push(blindfoldItems[i])
  menuGroups.value[BLINDFOLD_GROUP_NUMBER].menuItems = blindfoldMenuItems.value
  
  const isMe = connectionStore.getIsMe

  // build the learn depending on if they're already a coach
  const isCoach = connectionStore.getCoach
  if (isCoach != "eval")
    learnMenuItems.value.push(becomeACoach)
  learnMenuItems.value.push(learnWithCoach)
  menuGroups.value[LEARN_GROUP_NUMBER].menuItems = learnMenuItems.value

  // build the lichess based on if token exists
  //     bot challenge only for me
  lichessMenuItems.value = []

  // right now, lichess is only for the web
  // TEST ON EVERYTHING
  if (true || (deviceType != "ios" && deviceType != "android")) {
    if (lichessAccessToken == "")
      lichessMenuItems.value.push(lichessConnectItem)

    for (var i=0; i < lichessItems.length; i++)
      if (lichessItems[i].program != "lichess_bot_challenge" || isMe)
        lichessMenuItems.value.push(lichessItems[i])
    if (lichessAccessToken != "")
      lichessMenuItems.value.push(lichessDisconnectItem)
  }
  menuGroups.value[LICHESS_GROUP_NUMBER].menuItems = lichessMenuItems.value
})

function showIcon(item,whichIcon) {
  //console.log("show Icon ",whichIcon,item.label,isSubscriber,isOffline)
  switch (whichIcon) {
    case "locked" :
      if (item.webOnly && (deviceType == "ios" || deviceType == "android"))
        return (true)
      if (isSubscriber != 1 && item.subscriber === true)
        return (true)
      if (item.needsLichessToken === true && lichessAccessToken == "")
        return (true)
      return (false)
      break
    case "offline" :
      // stop showing offline
      return (false)

      // if (!isOffline)
      //   return (false)

      // // subscribers can do some things when off line
      // if (isSubscriber == 1 && item.canOffline === true)
      //     return (false)

      // // is the locked icon already displayed?
      // if (showIcon(item,"locked"))
      //   return (false)
      // return (true)
      break
    case "help" :
      if (item.help == undefined)
        return (false)
      if (item.help === false)
        return (false)
      if (showIcon(item,"offline"))
        return (false)
      if (showIcon(item,"locked"))
        return (false)
      return (true)
      break
  }
  return (false)
}

function menuItemClick(item,group) {
  if (item == "home") {
      connectionStore.setIsUsingNewMenus(true)
      emit("menu-item-click","home_menu",t("Home Menu"),"program")
      return
  }
  console.log("MENU ITEM CLICK",item,group.value)
  connectionStore.setProgramAccordionToOpen(group.value)
  if (showIcon(item,"offline")) {
    setupAlert(t("You're Off-line"),"That program is only available when on-line","alert","offline")
    return
  }
  if (showIcon(item,"locked")) {
    if (item.webOnly && (deviceType == "ios" || deviceType == "android"))
            setupAlert(t("Repertoire Import"),t("The drag&drop functionality requires the web version. After import, the repertoires can be used on your mobile device"),"alert","webonly")
    else
    if (item.needsLichessToken)
        setupAlert(t("Connect to Lichess"),t("That program requires that you've connected to lichess and given Chessvis permission to play on your behalf"),"alert","lichesstoken")
    else
        setupAlert(t("Become A Subscriber?"),t("That program is reserved for subscribers. Would you like to read about the benefits of subscribing?"),"yesno","subscribe")
    return
  }
  if (item.program == "puzzle_offline_toggle") {
    var workOfflinePuzzles = connectionStore.getWorkOfflinePuzzles
    workOfflinePuzzles = (workOfflinePuzzles == "no") ? "yes" : "no"
    connectionStore.setWorkOfflinePuzzles(workOfflinePuzzles)
  }
  connectionStore.setIsUsingNewMenus(false)
  emit("menu-item-click",item.program,item.label,"program")
}

function helpItemClick(item,group) {
  connectionStore.setProgramAccordionToOpen(group.value)

  // setDirection('root')
  //console.log("**** HELP clicked ",programName)
  emit("menu-help-item-click",item.program,item.label,"program")


}
</script>

<style scoped>

.accordion_item:hover {
  color: red !important;
  font-weight: bold;
}

</style>
